import React from 'react';
import { connect } from 'react-redux';
import { Col, Image } from 'react-bootstrap';
import EmojiRating from './EmojiRating'; // Assuming EmojiRating is a custom component


const Subrating = (props) => {
  const {
    onRate, id, image, name, description
  } = props;
  const handleOnRate = (rating) => {
    onRate({
      rating_criteria: id,
      score: rating
    });
  };
  const { score } = props;

  const handleRemoveRating = () => {
    onRate({
      rating_criteria: id,
      score: 0
    });
  };

  const imageURL = image || '/static/media/ImagePlaceholder.png';

  return (
    <Col xs={6} className='mt-3'>
      <Image
        src={imageURL}
        crossOrigin='anonymous'
        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <EmojiRating score={score} onRate={handleOnRate} handleRemoveRating={handleRemoveRating} interActive />
      </div>
      <p style={{ marginBottom: 0, fontWeight: 600, fontSize: '0.9em' }}>
        {' '}
        {name}{' '}
      </p>
      <p style={{ marginBottom: 0, fontSize: '0.8rem', color: 'grey' }}>
        {' '}
        {description}{' '}
      </p>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang
});

export default Subrating;
